import { LatLngExpression } from 'leaflet';

export function getPolylineFromGoogleMapsDirectionsResponse(
  response: google.maps.DirectionsResult,
): LatLngExpression[][] {
  return response.routes.map((route) =>
    route.overview_path.map((point) => [point.lat(), point.lng()]),
  );
}
